//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getTipologie() {
    return new Promise((resolve, reject) => {
      api
        .get("fluid/listFluidTypologies")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },

  getFluids() {
    return new Promise((resolve, reject) => {
      api
        .get("fluid/list")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          // title: "Attenzione",
          // message: response.data.errorMessage
          //});
          reject(error);
        });
    });
  },

  getRefrigerants() {
    return new Promise((resolve, reject) => {
      api
        .get("refrigerant/list")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: response.data.errorMessage
          //});
          reject(error);
        });
    });
  }
};
